import React, { ReactNode } from "react";
import styled from "styled-components";
import {
  CheckboxDefault,
  LinkNext,
  Theme,
  colors,
} from "@literati/public-ui-shared-react";
import { SubscriptionPlanCamelCase } from "lib/api/subscription";
import { LINKS } from "globalConfig";
import { isTbybMonthly2025OfferPlan } from "components/PlanSelection/planSelectionUtil";
import DLSErrorMessage from "components/DLS/DLSErrorMessage";

const CLASS_BASE = "payment-checkbox-legal-enrollment";
export const PaymentCheckboxLegalEnrollmentClassName = {
  BASE: CLASS_BASE,
} as const;

const StyledCheckboxDefault = styled(CheckboxDefault)`
  font-size: 0.875rem;
  & span {
    border-color: ${colors.tealShade3};
  }
`;

const StyledLinkNext = styled(LinkNext)`
  position: relative;
  z-index: 3;
`;

export interface PaymentCheckboxLegalEnrollmentProps {
  className?: string;
  errorMessage?: ReactNode;
  hasFieldError?: boolean;
  plan?: SubscriptionPlanCamelCase;
  touched?: boolean;
}

export const PaymentCheckboxLegalEnrollment = ({
  className = "",
  errorMessage = "Please agree with the terms to continue.",
  hasFieldError = false,
  plan,
  touched = false,
}: PaymentCheckboxLegalEnrollmentProps) => {
  const cls = PaymentCheckboxLegalEnrollmentClassName;

  const { amount, costPerBox, boxCount } = plan || {};
  const isAnnualPlan = boxCount === 12 && !isTbybMonthly2025OfferPlan(plan);

  const renewalVerbiage =
    isAnnualPlan && amount
      ? `on a yearly basis at ${amount}`
      : !isAnnualPlan && costPerBox
      ? `monthly for ${costPerBox}`
      : "monthly";

  return (
    <Theme>
      <StyledCheckboxDefault
        className={`${cls.BASE} ${className}`}
        label={
          <>
            I agree to enroll in Literati Kids Book Club and authorize my
            membership to be <strong>{renewalVerbiage}</strong>, charged to the
            card above until I{" "}
            <StyledLinkNext
              href={LINKS.terms}
              legacyBehavior={false}
              rel="noopener noreferrer"
              target="_blank"
            >
              cancel
            </StyledLinkNext>{" "}
            . I understand I can cancel anytime by signing into my account and
            clicking “cancel.”
          </>
        }
        name="legalEnrollment"
        data-testid="legalEnrollment"
      />
      {touched && hasFieldError ? (
        <DLSErrorMessage
          css={`
            padding-left: 0;
            text-align: center;
          `}
          message={errorMessage}
        />
      ) : null}
    </Theme>
  );
};

export default PaymentCheckboxLegalEnrollment;
